import {TransactionOpaque} from "./opaque/transactionOpaque";

export class ProcessPaymentDetailsRequest {
  paymentId: string;
  orderId: number;
  opaque: TransactionOpaque;

  constructor(paymentID: string, orderID: number, opaque: TransactionOpaque) {
    this.paymentId = paymentID;
    this.orderId = orderID;
    this.opaque = opaque;
  }
}
